/* Delegated logic for snippets/subscription-selector.liquid.
   Loaded once (browsers dedupe repeated same-src tags); serves every current and
   future instance, including markup injected via innerHTML (lazy cart drawer),
   because all handlers are delegated on document and all per-instance config is
   read from the DOM at event time (data-pqo-variants on the overlay root,
   data-sub-prices / data-sub-compare on the fieldset). */
(function() {
  /* --- Price display for the product-quick-overlay (pqo) host only --- */
  if (window._subSelInit) return;
  window._subSelInit = true;

  function currentVariantId(overlay) {
    var r = overlay.querySelector('[data-pqo-radio="' + overlay.id + '"]:checked');
    return r ? r.value : null;
  }
  function refresh(overlay) {
    var fs = overlay.querySelector('[data-sub-select="' + overlay.id + '"]');
    if (!fs) return;
    var V = {}, subMap = {}, cmpMap = {};
    try { V = JSON.parse(overlay.getAttribute('data-pqo-variants')); } catch (e) {}
    try { subMap = JSON.parse(fs.getAttribute('data-sub-prices')); } catch (e) {}
    try { cmpMap = JSON.parse(fs.getAttribute('data-sub-compare')); } catch (e) {}
    var vid = currentVariantId(overlay);
    var otPrice = (vid && V[vid]) ? V[vid].price : null;
    var subPrice = (vid && subMap[vid]) ? subMap[vid] : null;
    var cmpPrice = (vid && cmpMap[vid]) ? cmpMap[vid] : otPrice;

    var subRadio = fs.querySelector('[data-sub-plan="sub"]');
    var otRadio = fs.querySelector('[data-sub-plan="onetime"]');
    var subCard = fs.querySelector('[data-sub-card="sub"]');
    var avail = !vid || !!subPrice;
    if (subRadio) subRadio.disabled = !avail;
    if (subCard) subCard.classList.toggle('is-unavailable', !avail);
    if (!avail && subRadio && subRadio.checked && otRadio) otRadio.checked = true;

    var planRadio = fs.querySelector('[data-sub-radio="' + overlay.id + '"]:checked');
    var isSub = planRadio && planRadio.getAttribute('data-sub-plan') === 'sub';
    var otEl = fs.querySelector('[data-sub-ot-price]');
    var subEl = fs.querySelector('[data-sub-sub-price]');
    var cmpEl = fs.querySelector('[data-sub-sub-compare]');
    var otCmpEl = fs.querySelector('[data-sub-ot-compare]');
    if (otEl && otPrice) otEl.textContent = otPrice;
    if (subEl && subPrice) subEl.textContent = subPrice;
    if (cmpEl && cmpPrice) cmpEl.textContent = cmpPrice;
    if (otCmpEl) {
      if (cmpPrice && cmpPrice !== otPrice) { otCmpEl.textContent = cmpPrice; otCmpEl.style.display = ''; }
      else { otCmpEl.style.display = 'none'; }
    }
    fs.querySelectorAll('.sub-select__card').forEach(function(c) {
      var inp = c.querySelector('input[data-sub-radio]');
      c.classList.toggle('is-checked', !!(inp && inp.checked));
    });
    var atc = overlay.querySelector('[data-pqo-price="' + overlay.id + '"]');
    if (atc) {
      var want = (isSub && subPrice) ? subPrice : otPrice;
      if (want) setTimeout(function() { atc.textContent = want; }, 0);
    }
  }
  document.addEventListener('change', function(e) {
    var t = e.target;
    if (!t.matches('[data-sub-radio]') && !t.matches('[data-pqo-radio]')) return;
    var overlay = t.closest('.pqo-overlay');
    if (overlay) refresh(overlay);
  });
  function initAll() {
    document.querySelectorAll('.pqo-overlay').forEach(function(ov) {
      if (ov.id && ov.querySelector('[data-sub-select="' + ov.id + '"]')) refresh(ov);
    });
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();

(function() {
  /* --- MRR line item property sync (host-agnostic) ---
     Keeps the hidden properties[_mrr] input in step with the selling_plan radio:
     a value is set only when a subscription plan is chosen, so the property is
     present on subscription lines and absent on one-time lines. */
  if (window._subMrrInit) return;
  window._subMrrInit = true;

  /* Inject/remove properties[_mrr] as a real child of the product <form>.
     The selling_plan radio lives in the drawer (linked via the form attribute),
     but the cart collector only scans inputs nested inside the form element, so
     a form-attribute-linked input would be missed — we mirror it into the form. */
  function syncFor(radio) {
    var fid = radio.getAttribute('form');
    if (!fid) return;
    var form = document.getElementById(fid);
    if (!form) return;
    var isSub = radio.checked && !!radio.value;
    var hidden = form.querySelector('input[data-sub-mrr-prop]');
    if (isSub) {
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'properties[_mrr]';
        hidden.setAttribute('data-sub-mrr-prop', '1');
        form.appendChild(hidden);
      }
      hidden.value = 'monthly';
    } else if (hidden) {
      hidden.parentNode.removeChild(hidden);
    }
  }
  document.addEventListener('change', function(e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[name="selling_plan"]')) syncFor(t);
  });
  function initAll() {
    document.querySelectorAll('input[name="selling_plan"]:checked').forEach(syncFor);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
